import Multiselect from 'vue-multiselect'
import { required, minLength } from 'vuelidate/lib/validators'
import { policyService } from '../../services/PolicyService'

export default {
    name: 'PolicyList',

    components: {
        Multiselect
    },

    data: () => {
        return {
            loading: true,

            policy: {}
        }
    },
    validations: {
        policy: {
            Description: {
                required,
                minLength: minLength(4)
            }
        }
    },
    computed: {
        isValid() {
            return !this.$v.$anyError
        }
    },

    // Fetches when the component is created.
    created() {
        var model = this;

        var policyPromise = policyService.getPolicy(model.$route.params.id)
            .then(response => {
                model.policy = response.data;
            })

        axios.all([policyPromise])
            .then(axios.spread(function () {
                model.loading = false;
            }));
    },

    methods: {
        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //
        backButtonClick: function () {
            this.$router.push('/policies');
        },
        savePolicy: function () {
            var model = this;

            if (!model.validate())
                return;

            var policyPromise = policyService.savePolicy(model.$route.params.id, model.policy)
                .then(response => {
                    // if success go to list
                    this.$router.push('/policies');
                })

            axios.all([policyPromise])
                .then(axios.spread(function () {
                    model.loading = false;
                }));
        }
    },
}
